import { render, staticRenderFns } from "./EpaHeader.vue?vue&type=template&id=18066d7a&scoped=true"
import script from "./EpaHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./EpaHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EpaHeader.vue?vue&type=style&index=0&id=18066d7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18066d7a",
  null
  
)

export default component.exports